import React from "react";

export default function SectionHeader({ eyebrow, title, subtitle, align = "left", light = false }) {
  const alignCls = align === "center" ? "text-center mx-auto" : "";
  const color = light ? "text-white" : "text-neutral-900";
  const sub = light ? "text-white/75" : "text-neutral-600";
  const eye = light ? "text-[#E8F1EA]" : "text-[#0B5D1E]";

  return (
    <div className={`max-w-3xl ${alignCls}`}>
      {eyebrow && (
        <span className={`inline-flex items-center gap-3 text-xs font-bold tracking-[0.25em] uppercase ${eye} mb-4`}>
          <span className={`h-[2px] w-8 ${light ? "bg-white/60" : "bg-[#0B5D1E]"}`} />
          {eyebrow}
        </span>
      )}
      <h2 className={`font-heading font-bold text-3xl sm:text-4xl lg:text-[2.75rem] leading-[1.1] ${color}`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-4 text-base sm:text-lg ${sub} leading-relaxed`}>{subtitle}</p>
      )}
    </div>
  );
}
